import get from 'lodash/get';
import {
  FETCH_SHOPIFY_SHOPS,
  SET_SHOP,
  SET_SHOPIFY_MSD_ORDER,
  SET_SHOPIFY_MULTIPLE_ORDERS,
  UPDATE_SHOPIFY_MULTIPLE_ORDERS,
  UPDATE_SHOPIFY_MULTIPLE_ORDERS_SHALLOW,
  UPDATE_SHOPIFY_MSD_ORDER,
  UPDATE_SHOPIFY_MSD_ORDER_SHALLOW,
  CLEAR_SHOPIFY_ORDERS,
  SHOPIFY_BOOK_AGAIN,
  CLEAR_SHOPIFY_BOOK_AGAIN,
  LOCATION_DRAWER_SHOPIFY_ROUTE_OPTIMIZATION,
  UPDATE_SHOPIFY_OPTIMIZE_QUOTES_STATUS,
} from 'actions/shopify-actions';
import { QUOTE_OPTIMIZED_FAILED } from 'constants/booking-constants';

const initialState = {
  shops: null,
  shop: null,
  msdOrder: {},
  multipleOrders: [],
  bookAgain: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHOPIFY_SHOPS.SUCCESS: {
      return {
        ...state,
        shops: get(action, ['data', 'connections'], []),
      };
    }
    case SET_SHOP: {
      return {
        ...state,
        shop: action.payload,
      };
    }
    case SET_SHOPIFY_MSD_ORDER: {
      return {
        ...state,
        msdOrder: get(action, 'order', {}),
      };
    }
    case SET_SHOPIFY_MULTIPLE_ORDERS: {
      return {
        ...state,
        multipleOrders: get(action, 'orders', []),
      };
    }
    case UPDATE_SHOPIFY_MULTIPLE_ORDERS_SHALLOW:
    case UPDATE_SHOPIFY_MULTIPLE_ORDERS: {
      const { index, order } = action.payload;

      // single order update in bulk screen
      if (!isNaN(index)) {
        let newOrders = [];
        newOrders = [...state.multipleOrders];
        newOrders.splice(index, 1, order);
        return {
          ...state,
          multipleOrders: newOrders,
        };
      }

      // remove order in bulk order page
      const { multipleOrders } = action.payload;
      return {
        ...state,
        multipleOrders,
      };
    }
    case UPDATE_SHOPIFY_MSD_ORDER_SHALLOW:
    case UPDATE_SHOPIFY_MSD_ORDER: {
      const { order } = action.payload;
      return {
        ...state,
        msdOrder: order,
      };
    }
    case LOCATION_DRAWER_SHOPIFY_ROUTE_OPTIMIZATION.ERROR: {
      return {
        ...state,
        msdOrder: {
          ...state.msdOrder,
          optimizeQuotesStatus: {
            status: QUOTE_OPTIMIZED_FAILED,
          },
        },
      };
    }
    case LOCATION_DRAWER_SHOPIFY_ROUTE_OPTIMIZATION.SUCCESS: {
      const { quoteV2, optimizeQuotesStatus } = action.payload;
      return {
        ...state,
        msdOrder: {
          ...state.msdOrder,
          optimizeQuotesStatus,
          quoteV2,
        },
      };
    }
    case UPDATE_SHOPIFY_OPTIMIZE_QUOTES_STATUS: {
      return {
        ...state,
        msdOrder: {
          ...state.msdOrder,
          optimizeQuotesStatus: {
            ...state.optimizeQuotesStatus,
            ...action.payload,
          },
        },
      };
    }
    case CLEAR_SHOPIFY_ORDERS: {
      return {
        ...state,
        msdOrder: {},
        multipleOrders: [],
      };
    }
    case SHOPIFY_BOOK_AGAIN: {
      const { orders } = action.payload;
      return {
        ...state,
        bookAgain: orders,
      };
    }
    case CLEAR_SHOPIFY_BOOK_AGAIN: {
      return {
        ...state,
        bookAgain: [],
      };
    }
    default: {
      return state;
    }
  }
};
